import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import {
  PRICE_COMPONENT_LABEL,
  PRICE_COMPONENT_PRODUCT_NAME,
  PriceComponentType,
} from '../../Enums/price-component-type.enum';
import { PlanPriceResponse } from '../../Interfaces/api/backoffice/plan.interface';

export class PlanPrice {
  id = '';
  plan_id = '';
  component_type: string | null = null;
  offer_type: string | null = null;
  billing_model: string | null = null;
  billing_interval: string | null = null;
  currency: string | null = null;
  unit_amount = 0;
  is_active = false;
  stripe_price_id: string | null = null;
  stripe_product_id: string | null = null;
  metadata: Record<string, unknown> | null = null;
  created_at: string | null = null;
  updated_at: string | null = null;

  constructor(data: Partial<PlanPriceResponse> = {}) {
    Object.assign(this, data);
  }

  get componentLabelKey(): string {
    return this.component_type
      ? (PRICE_COMPONENT_LABEL[this.component_type as PriceComponentType] ?? this.component_type)
      : VALUE_UNRESOLVED;
  }

  get sharedProductNameKey(): string {
    return this.component_type
      ? (PRICE_COMPONENT_PRODUCT_NAME[this.component_type as PriceComponentType] ??
          this.component_type)
      : VALUE_UNRESOLVED;
  }

  get isAgent(): boolean {
    return this.component_type === PriceComponentType.AGENT;
  }

  get stripePriceLabel(): string {
    return this.stripe_price_id || VALUE_UNRESOLVED;
  }

  get stripeProductLabel(): string {
    return this.stripe_product_id || VALUE_UNRESOLVED;
  }
}
